import React from "react";
import * as styles from "./style.mod.scss";
import Trustpilot from "assets/images/TPStars.svg";
import TrustpilotLogo from "assets/images/TP.svg";
import locale from "locales";
import getImagePath from "helpers/get-image-path";

const ReviewImages = ({ showReview }) => {
  const reviewLoc = locale.pages.reviews;

  if (!showReview?.showSvg) return <></>;
  
  return (
    <div className={styles.reviewsContainer}>
      <div className={styles.trustpilotReviews}>
        <img src={Trustpilot} alt="Trustpilot" />
        <p>{reviewLoc.trustpilot}</p>
        <div className={styles.tpLogo}>
          <img src={TrustpilotLogo} alt="Trustpilot" />
        </div>
      </div>
      <div className={styles.borderLine}></div>
      <div className={styles.googleReviews}>
        {showReview.googleBadge && 
        <img src={getImagePath(showReview.googleBadge)} />}
      </div>
    </div>
  );
};

export default ReviewImages;